// extracted by mini-css-extract-plugin
module.exports = {"container":"DebtFormTitle_container__CLeiZ","text":"DebtFormTitle_text__4wtAc"};